import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { AutoOrderSettingApi, UpdateAutoOrderSettingBody } from 'api';

export const findOneAutoOrderSettingWithEntity = createAsyncThunk(
  'autoOrderSetting/findOneAutoOrderSettingWithEntity',
  async (any, { rejectWithValue }) => {
    try {
      const response = await AutoOrderSettingApi.findWithEntity();

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateAutoOrderSetting = createAsyncThunk(
  'autoOrderSetting/updateAutoOrderSetting',
  async (
    params: { id: string; body: UpdateAutoOrderSettingBody },
    { rejectWithValue }
  ) => {
    try {
      const { id, body } = params;
      const response = await AutoOrderSettingApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface InitialState {
  data: any | undefined;
  shouldReloadBalanceWithTimeNumber: number | undefined;
  shouldReloadChainOrderWithTimeNumber: number | undefined;
}

const initialState: InitialState = {
  data: undefined,
  shouldReloadBalanceWithTimeNumber: undefined,
  shouldReloadChainOrderWithTimeNumber: undefined,
};

const autoOrderSettingSlice = createSlice({
  name: 'autoOrderSetting',
  initialState,
  reducers: {
    triggerReloadBalanceTable: state => {
      state.shouldReloadBalanceWithTimeNumber = new Date().getTime();
    },
    triggerReloadChainOrderTable: state => {
      state.shouldReloadChainOrderWithTimeNumber = new Date().getTime();
    },
  },
  extraReducers: builder => {
    builder.addCase(
      findOneAutoOrderSettingWithEntity.fulfilled,
      (state, action) => {
        const { data } = action.payload;
        state.data = data;
      }
    );
    builder.addCase(updateAutoOrderSetting.fulfilled, (state, action) => {
      const { data } = action.payload;
      state.data = {
        ...state.data,
        ...data,
      };
    });
  },
});

const { actions, reducer: autoOrderSettingReducer } = autoOrderSettingSlice;

export const { triggerReloadBalanceTable, triggerReloadChainOrderTable } =
  actions;

export default autoOrderSettingReducer;
